<template>
  <div>
    <!--商品信息-->
    <van-row class="sku-bg">
      <van-col span="6">
        <van-image width="6rem" height="6rem" fit="contain" :src="imgUrl + pdtInfo.productName"
          @click="showImg(pdtInfo.productName)" />
      </van-col>
      <van-col span="12">
        <div class="pdt-value">{{ pdtInfo.productCode }}</div>
        <div class="sku-info">{{ pdtInfo.productName }}/{{ pdtInfo.barCode }}/{{ pdtInfo.color }}</div>
      </van-col>
      <van-col span="6">
        <div class="pdt-stock">库存：{{ pdtInfo.totalInventory | AmtFormat }}</div>
        <div class="sku-expected">预计可售{{ pdtInfo.estimatedSellingDays }}天</div>
      </van-col>
    </van-row>
    <!--折线图-->
    <div class="van-sidebar-item van-sidebar-item--select">7天销售趋势</div>
    <br />
    <ve-line :data="chartData"></ve-line>
    <!--每日销售情况-->
    <el-table ref="pdtItemRef" :data="pdtItem">
      <el-table-column prop="saleDate" label="日期" align="center" />
      <el-table-column prop="salesAmount" label="销售额" align="center" />
      <el-table-column prop="salesQuantity" label="销售数量" align="center" />
      <el-table-column prop="avgSellingPrice" label="平均售价" align="center" />
    </el-table>
  </div>
</template>

<script>
import { reqProductDailySales } from "@/api/board";
import { ImagePreview } from 'vant';

export default {
  name: "pdtRankItem",

  data() {
    return {
      imgUrl: Glob.IMG_URL,

      pdtInfo: null,

      pdtItem: [],

      //折线图
      chartData: {
        columns: ["日期", "销售额", "销售数量", "平均售价"],
        rows: [],
      },

      //请求参数
      reqData: {
        startDate: null,
        endDate: null,
        productCode: null,
      },
    }
  },

  computed: {

  },

  created() {
    //获取跳转入参
    this.reqData.startDate = this.$route.params.startDate;
    this.reqData.endDate = this.$route.params.endDate;
    this.reqData.productCode = this.$route.params.pdtInfo.productName;
    this.pdtInfo = this.$route.params.pdtInfo;
    //获取数据
    this.getProductDailySales();
  },

  mounted() {

  },

  methods: {
    //展示图片
    showImg(pdtName) {
      ImagePreview([this.imgUrl + pdtName]);
    },
    //获取数据
    getProductDailySales() {
      //发出请求
      reqProductDailySales(this.reqData).then((res) => {
        this.pdtItem = res;
        //解析折线图数据
        this.pdtItem.forEach((item) => {
          this.chartData.rows.push(
            {
              "日期": item.saleDate,
              "销售额": item.salesAmount,
              "销售数量": item.salesQuantity,
              "平均售价": item.avgSellingPrice,
            });
        });
      });
    },
  },

}
</script>

<style scoped lang="less">
.sku-bg {
  background-color: #fff;
}

.pdt-value {
  font-size: 0.9rem;
  padding-left: 0.5rem;
  padding-top: 0.5rem;
}

.sku-info {
  font-size: 0.6rem;
  padding-left: 0.5rem;
  padding-top: 2.5rem;
  color: #969799;
}

.pdt-stock {
  font-size: 0.8rem;
  color: #379bff;
  border-color: #379bff;
  padding: 0.4rem 0.6rem;
  background-color: #fff;
  border: 1px solid #379bff;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: 2rem;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.2s;
  -webkit-appearance: none;
  border-radius: 5vw;
  margin-top: 0.5rem;
}

.sku-expected {
  font-size: 0.6rem;
  padding-left: 0.5rem;
  padding-top: 1.6rem;
  color: #969799;
}
</style>


// WEBPACK FOOTER //
// src/view/board/pdtRankItem.vue